import React, { useState, useEffect, useDeferredValue } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { useUser } from '../../contexts/UserContext';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

interface SearchBarProps {
    onSearchChange: (query: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearchChange }) => {
    const { user } = useUser();
    const [searchTerm, setSearchTerm] = useState('');
    const deferredSearchTerm = useDeferredValue(searchTerm);

    useEffect(() => {
        if (deferredSearchTerm.length >= 3) {
            onSearchChange(deferredSearchTerm);
        } else if (deferredSearchTerm.length === 0) {
            onSearchChange('');
        }
    }, [deferredSearchTerm, onSearchChange]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    const handleClear = () => {
        setSearchTerm('');
        onSearchChange('');
    };

    useEffect(() => {
        if (!user) {
            setSearchTerm('');
        }
    }, [user]);

    return (
        <TextField
            label="Search Events"
            variant="outlined"
            value={searchTerm}
            onChange={handleChange}
            fullWidth
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={handleClear}
                            style={{ visibility: searchTerm ? 'visible' : 'hidden' }}
                        >
                            <ClearIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default SearchBar;
